import BASEURLGESTTOR from '../api/gesttor'
import { baixarLancamentoPayload } from '../../interfaces/baixas'

export function baixarLancamento (payload: baixarLancamentoPayload) {
    return BASEURLGESTTOR.post('/lancamentos/baixa', payload)
}

export function listarBaixas (id: string) {
    return BASEURLGESTTOR.get (`/lancamentos/baixa/${id}`)
}

export function apagarBaixa (id: string) {
    return BASEURLGESTTOR.delete(`/lancamentos/baixa/${id}`)
}